module.exports = __webpack_public_path__ + "img/l_01.a6ff1c8b.png";